<app-header></app-header>
<section class="pills-int bg-grey">

    <div class="container h-100">


        <div class="col-lg-12 pills-int-inner">
            <div class="col-lg-7 col-md-7 col-12 pills-int-inner-content">

                <div class="col-lg-12 head-tit">
                    <p class="rco fw-bold mb-1">#pills</p>
                    <h1 [innerHTML]="pill.title" class="mb-4"></h1>
                </div>

                <div class="col-lg-12 social-btn-blq">
                    <div class="col-2" style="width: 180px;">
                        <div class="sa-social">
                            <div class="sa-share-text">
                                <span>Compartir&nbsp;
                                    <svg width="30" height="30" viewBox="0 0 23 23" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M21.0853 5.27276C21.0853 3.41924 19.5836 1.91666 17.7311 1.91666C15.8786 1.91666 14.3769 3.41924 14.3769 5.27276C14.3769 5.67508 14.4477 6.06086 14.5774 6.41833L8.07984 9.65646C7.48093 8.74045 6.44656 8.13525 5.27091 8.13525C3.41846 8.13525 1.91675 9.63783 1.91675 11.4914C1.91675 13.3449 3.41846 14.8475 5.27091 14.8475C6.44696 14.8475 7.48164 14.2419 8.08045 13.3253L14.582 16.5692C14.4493 16.9302 14.3769 17.3202 14.3769 17.7272C14.3769 19.5807 15.8786 21.0833 17.7311 21.0833C19.5836 21.0833 21.0853 19.5807 21.0853 17.7272C21.0853 15.8737 19.5836 14.3711 17.7311 14.3711C16.6283 14.3711 15.6498 14.9036 15.0385 15.7256L8.4848 12.4549C8.57606 12.1497 8.62508 11.8263 8.62508 11.4914C8.62508 11.1558 8.57585 10.8317 8.48422 10.5259L15.0298 7.26265C15.6406 8.09132 16.6231 8.62887 17.7311 8.62887C19.5836 8.62887 21.0853 7.12629 21.0853 5.27276ZM15.3353 17.7272C15.3353 16.4033 16.4079 15.33 17.7311 15.33C19.0543 15.33 20.1269 16.4033 20.1269 17.7272C20.1269 19.0512 19.0543 20.1244 17.7311 20.1244C16.4079 20.1244 15.3353 19.0512 15.3353 17.7272ZM5.27091 9.09414C3.94773 9.09414 2.87508 10.1674 2.87508 11.4914C2.87508 12.8153 3.94773 13.8886 5.27091 13.8886C6.5941 13.8886 7.66675 12.8153 7.66675 11.4914C7.66675 10.1674 6.5941 9.09414 5.27091 9.09414ZM15.3353 5.27276C15.3353 3.94882 16.4079 2.87554 17.7311 2.87554C19.0543 2.87554 20.1269 3.94882 20.1269 5.27276C20.1269 6.59671 19.0543 7.66998 17.7311 7.66998C16.4079 7.66998 15.3353 6.59671 15.3353 5.27276Z"
                                            fill="#333333" />
                                    </svg>
                                </span>
                            </div>
                            <ul class="sa-share-buttons">
                                <li><a (click)="shareOnFacebook()" title="Compartir en facebook" target="_blank"><svg
                                            enable-background="new 0 0 32 32" height="32px" class="social" version="1.0"
                                            viewBox="0 0 32 32" width="32px" xml:space="preserve"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <path
                                                d="M18,32V18h6l1-6h-7V9c0-2,1.002-3,3-3h3V0c-1,0-3.24,0-5,0c-5,0-7,3-7,8v4H6v6h6v14H18z">
                                            </path>
                                        </svg></a></li>
                                <li><a (click)="shareOnLinkedin()" target="_blank" title="Compartir en Linkedin">
                                        <svg width="32px" height="32px" viewBox="0 0 32 32">
                                            <path
                                                d="M.404 30.586h6.862V9.954H.404v20.632zM3.834 7.137h-.046C1.488 7.137 0 5.547 0 3.57 0 1.544 1.536 0 3.878 0c2.348 0 3.794 1.543 3.836 3.57 0 1.977-1.488 3.567-3.88 3.567M32 30.586h-6.86v-11.04c0-2.772-.992-4.668-3.476-4.668-1.892 0-3.024 1.282-3.52 2.512-.182.442-.226 1.056-.226 1.672v11.524H11.06s.088-18.7 0-20.632h6.858v2.922c.914-1.408 2.542-3.408 6.184-3.408 4.512 0 7.898 2.95 7.898 9.29v11.828z">
                                            </path>
                                        </svg></a></li>

                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12 share-btn-blq">
                    <a routerLink="/pills" class="me-3" title="Ver todos">
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path class="path1"
                                d="M56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28Z"
                                fill="#DADADA" />
                            <path
                                d="M18 25C19.656 25 21 26.344 21 28C21 29.656 19.656 31 18 31C16.344 31 15 29.656 15 28C15 26.344 16.344 25 18 25Z"
                                fill="#464646" />
                            <path
                                d="M38 25C39.659 25 41 26.344 41 28C41 29.656 39.659 31 38 31C36.344 31 35 29.656 35 28C35 26.344 36.344 25 38 25Z"
                                fill="#464646" />
                            <path
                                d="M28 25C29.656 25 31 26.344 31 28C31 29.656 29.656 31 28 31C26.344 31 25 29.656 25 28C25 26.344 26.344 25 28 25Z"
                                fill="#464646" />
                        </svg>
                    </a>


                    <a *ngIf="id_prev" [routerLink]="id_prev ? ['/pills/', id_prev] : null" class="me-3"
                        title="Anterior">
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path class="path1"
                                d="M56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28Z"
                                fill="#DADADA" />
                            <path class="path2"
                                d="M31.619 38.1306C31.2541 38.1327 30.9033 37.9893 30.6442 37.7319L22.4061 29.4819C22.1462 29.2237 22 28.8723 22 28.5056C22 28.139 22.1462 27.7876 22.4061 27.5294L30.6442 19.2794C31.1826 18.7402 32.0555 18.7402 32.5939 19.2794C33.1323 19.8185 33.1323 20.6927 32.5939 21.2319L25.3169 28.5056L32.5939 35.7794C32.8538 36.0376 33 36.389 33 36.7556C33 37.1223 32.8538 37.4737 32.5939 37.7319C32.3348 37.9893 31.984 38.1327 31.619 38.1306Z"
                                fill="#444444" />


                        </svg>
                    </a>

                    <a *ngIf="id_next" [routerLink]="id_next ? ['/pills/', id_next]: null" class="me-3"
                        title="Siguiente">
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path class="path1"
                                d="M56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28Z"
                                fill="#DADADA" />
                            <path class="path2"
                                d="M23.381 17.8694C23.7459 17.8673 24.0967 18.0107 24.3558 18.2681L32.5939 26.5181C32.8538 26.7763 33 27.1277 33 27.4944C33 27.861 32.8538 28.2124 32.5939 28.4706L24.3558 36.7206C23.8174 37.2598 22.9445 37.2598 22.4061 36.7206C21.8677 36.1815 21.8677 35.3073 22.4061 34.7681L29.6831 27.4944L22.4061 20.2206C22.1462 19.9624 22 19.611 22 19.2444C22 18.8777 22.1462 18.5263 22.4061 18.2681C22.6652 18.0107 23.016 17.8673 23.381 17.8694Z"
                                fill="#444444" />

                        </svg>
                    </a>


                </div>


            </div>

            <div class="col-md-6 col-12 pills-int-inner-video">
                <div class="video-container-pill">
                    <iframe *ngIf="pill.videoUrl" [src]="videoURI" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>

        </div><!-- fin bloque pills-int-inner-->

    </div><!-- fin container-->


</section>
<app-footer-main></app-footer-main>